module.exports = __webpack_public_path__ + "media/components/profile/static/icon-user-282387938d362fbb3b169fb1157394cf.svg";